'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'soap';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'e06e';
var svgPathData = ['M320,128a64,64,0,1,0,64,64A64,64,0,0,0,320,128ZM208,0a48,48,0,1,0,48,48A48,48,0,0,0,208,0ZM384,0a32,32,0,1,0,32,32A32,32,0,0,0,384,0Z', 'M416,192a95.42,95.42,0,0,1-30.94,70.21A95.8,95.8,0,0,1,352,448H160a96,96,0,0,1,0-192h88.91A95.3,95.3,0,0,1,224,192H96A96,96,0,0,0,0,288V416a96,96,0,0,0,96,96H416a96,96,0,0,0,96-96V288A96,96,0,0,0,416,192ZM96,352a64,64,0,0,0,64,64H352a64,64,0,0,0,0-128H160A64,64,0,0,0,96,352Z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.faSoap = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = ligatures;
exports.unicode = unicode;
exports.svgPathData = svgPathData;